module.exports = __webpack_public_path__ + "img/ava.76a4ad8e.png";